export default {
  payouts_support_payments: "お支払いに関するお問い合わせは {finance_email} までご連絡ください。"
};
